import { useProductFlags } from '@/screens/Product/hooks/use-product-flags'
import { useProduct } from '@/screens/Product/hooks/useProduct'
import { useProductBonus } from '@/screens/Product/hooks/useProductBonus'

import { getBotInfo } from '@/shared/lib/seo'
import { ProductControl } from '@/shared/types/product-types'

import { ProductTradeIn } from '../../../product-trade-in/ProductTradeIn'
import { BuyButtonsPanel } from '../buy-buttons-panel/BuyButtonsPanel'
import { PricesBlock } from '../product-price-widget/PricesBlock/PricesBlock'
import { ProductPriceWidget } from '../product-price-widget/ProductPriceWidget'

import cl from './product-price-block.module.scss'

export const ProductPriceBlock = () => {
	const { product } = useProduct()
	const isBot = getBotInfo('isDetected')
	const { productIsInStock, isProductBuy } = useProductFlags()
	const showPrice =
		product.PRICE &&
		!!product.PRICE.VALUE &&
		product.VISIBLE_PRICE &&
		!product.CONTROL?.includes(ProductControl.HidePrice)
	const isBuyHidden = product.CONTROL?.includes(ProductControl.HideBuy)
	const renderPrice = isProductBuy && showPrice
	const { discountPrice } = useProductBonus(product.ID, !showPrice || !productIsInStock)

	return (
		<>
			{(showPrice || !isBuyHidden) && (
				<div className={cl.productPannel} data-mb-price={discountPrice}>
					{showPrice && !isProductBuy && (
						<PricesBlock currentPrice={product.PRICE.VALUE} oldPrice={product.OLD_PRICE?.VALUE} />
					)}

					{renderPrice && (
						<ProductPriceWidget
							className={cl.productPriceWidget}
							productId={product.ID}
							price={product.PRICE.VALUE}
							oldPrice={product.OLD_PRICE?.VALUE}
							isBot={isBot}
							productIsInStock={productIsInStock}
						/>
					)}
					<BuyButtonsPanel {...product} fullWidth fastOrderBtnType="outlined" />
				</div>
			)}
			<ProductTradeIn />
		</>
	)
}
